module.exports = {"320571050":"娄葑街道","320571051":"斜塘街道","320571052":"唯亭街道","320571053":"胜浦街道","320571400":"湖西社区工作委员会","320571401":"湖东社区工作委员会","320571402":"月亮湾社区工作委员会","320571403":"东沙湖社区工作委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320571.json
// module id = 870
// module chunks = 0